import React, { useCallback, useState } from "react";
import { Form, FormSpy } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";
import queryString from "query-string";
import { useHistory } from "react-router-dom";

import StepperActions from "../../components/StepperActions";
import { ReceiverField } from "../../../../components/fields/ReceiverField";
import { BranchField } from "../../../../components/fields/BranchField";
import { TextField } from "../../../../components/forms/fields";
import { Button, colorFirm } from "../../../../components/Buttons/Button/Button";
import { FORM_DATA } from "../../constants";
import { Dialog } from "../../../../components/dialogs/Dialog/Dialog";
import { Spinner } from "../../../../components/Loaders/Spinner/Spinner";
import SimpleBackdrop from "../../../../components/SimpleBackdrop";
import { useSearchParams } from "../../../../hooks/searchParams";
import { ROUTES_MAP } from "../../../../routes/constants";
import { CONFIG_MANAGER_LIGHT_STEPS } from "../../index";

import { configManagerLiteStepOneSelector } from "./services/selectors";
import { requestFirsStep } from "./services/actions";
import { urlsValidator } from "./validation";

import styles from "./styles.module.scss";

const First = () => {
    const history = useHistory();
    const { template_code, ...searchParams } = useSearchParams();
    const [ receiverCode, setReceiverCode ] = useState(null);
    const [ branchCodes, setBranchCodes ] = useState(null);

    const dispatch = useDispatch();
    const { isLoading, isOpen, isOpenBackdrop } = useSelector(configManagerLiteStepOneSelector);

    const handleSubmitForm = useCallback(
        (values) => {
            dispatch(requestFirsStep({
                ...FORM_DATA,
                ...values,
                template_code
            }));
        },
        [ dispatch, template_code ]
    );

    const handleChangeForm = useCallback(
        ({ receiver_code, branch_codes }) => {
            if(receiver_code !== receiverCode && !template_code){
                setReceiverCode(receiver_code);
            }

            if(branch_codes !== branchCodes && !template_code){
                setBranchCodes(branch_codes);
            }
        },
        [ receiverCode, template_code, branchCodes ]
    );

    const onClickNextState = useCallback(
        () => {
            history.push(
                `${ROUTES_MAP.configManagerLite.path}/${CONFIG_MANAGER_LIGHT_STEPS.two}?${queryString.stringify({ template_code, ...searchParams })}`
            );
        },
        [ template_code, history, searchParams ]
    );

    return (
        <>
            <StepperActions activeStep={0}/>
            <Form
                onSubmit={handleSubmitForm}
                initialValues={{
                    receiver_code: searchParams.receiver_code,
                    branch_codes: searchParams.branch_codes
                }}
                render={({ handleSubmit }) => (
                    <form
                        className={styles.form}
                        onSubmit={handleSubmit}
                    >
                        <FormSpy
                            onChange={({ pristine, values }) => {
                                if (pristine) {
                                    return;
                                }

                                handleChangeForm(values);
                            }}
                        />

                        <div className={styles.selects}>
                            <ReceiverField
                                label="Please specify Receiver*"
                                errorMessage="Platform"
                                placeholder="Select Receiver"
                                isRequired
                            />

                            <BranchField
                                label="Please specify Site"
                                errorMessage="Site"
                                placeholder="Select Site"
                                name="branch_codes"
                                isRequired
                            />
                        </div>

                        <TextField
                            className={styles.textarea}
                            label="Put here 1-5 examples of Start URLs divided by Enter*"
                            name={"urls"}
                            errorMessage="Urls"
                            placeholder={"https://site.com?query=nike\nhttps://site.com?query=apple\nhttps://site.com?query=red+apple\netc."}
                            validator={urlsValidator}
                            rows={11}
                        />

                        <div className={styles.controls}>
                            <Button
                                className={styles.btnClassName}
                                type="submit"
                                colorFirm={colorFirm.firm5}
                                disabled={isLoading}
                            >
                                Save
                            </Button>

                            {
                                template_code && (
                                    <Button
                                        className={styles.btnClassName}
                                        colorFirm={6}
                                        onClick={onClickNextState}
                                    >
                                        Next Step
                                    </Button>
                                )
                            }
                        </div>
                    </form>
                )}
            />

            <Dialog
                title="Loading..."
                isOpen={isOpen}
            >
                We are working to prepare all data needed to Next Step
                <div className={styles.dialogSpinner}>
                    <Spinner/>
                </div>
            </Dialog>

            <SimpleBackdrop isOpen={isOpenBackdrop}/>
        </>
    );
};

export default First;
